import React from 'react';
import {BrowserRouter as Router, Route, IndexRoute, IndexRedirect} from 'react-router-dom'


import MainComponent from './pages/MainComponent.jsx';
import LoginComponent from './pages/public/LoginComponent.jsx';
import ForgotPasswordComponent from './pages/public/ForgotPasswordComponent.jsx';
import ResetPasswordComponent from './pages/public/ResetPasswordComponent.jsx';
import VerifyEmailComponent from './pages/public/VerifyEmailComponent.jsx';
import MesAbonnements from './pages/client/MesAbonnements.jsx'
import Dashboard from './pages/client/Dashboard.jsx';
import AuthorizationService from './services/AuthorizationService';

import SubscriptionDetails from "./pages/client/SubscriptionDetails.jsx";
import MyCoordinates from "./pages/client/MyCoordinates.jsx";
// import MesConseils from "./pages/client/MesConseils.jsx";
import MyInvoices from "./pages/client/MyInvoices.jsx";
import MyInvoicesDetails from "./pages/client/MyInvoicesDetails.jsx";
import ManageSubscription from './pages/client/ManageSubscription.jsx';
import MyAssistance from './pages/client/MyAssistance.jsx';
import {getUrlParameters} from './pages/utils/UrlUtils';


export default class Routes extends React.Component {

	checkLogin(nextState, replace, resume) {
		if(!AuthorizationService.auth.authenticated){
			// const {kc_idp_hint: idpHint = ""} = getUrlParameters() || {};
			AuthorizationService.auth.login({idpHint: KC_IDP});
		} else {
			resume();
		}
	}
	render() {
		const {history} = this.props;
		return (
			<Router basename={BASE_PATH}>
				<MainComponent history={history}>
					{/*
						<Route path={mesAbonnements_url.route} component={MesAbonnements}/>
					<Route path={mesConseils_url.route +"/:selectedOfferCode"} component={MesConseils}/>
					<Route path={mesConseils_url.route} component={MesConseils}/>
					<Route path={myAssistance_url.route} component={MyAssistance}/> 
					<Route path={dashboard_url.route} history={history} component={Dashboard}/>
					<Route path={mesFactures_url.route} component={MyInvoices}/>*/}
					<Route path={manageSubscription_url.path} render={() => <ManageSubscription />} history={history}/>
					<Route path={myInvoicesDetails_url.path} render={() => <MyInvoicesDetails />} history={history}/>
					<Route path={subscriptionDetails_url.path} render={() => <SubscriptionDetails />} history={history}/>
					<Route path={mesCoordonnees_url.path} render={() => <MyCoordinates />} history={history}/>
				</MainComponent>
			</Router>

		);
	}
}



// WEBPACK FOOTER //
// ./src/opencell/routes.js